import ProductListSkeleton from "./product-list-skeleton";
import { Skeleton } from "@/components/ui/skeleton";

export default function ProductShowcaseSkeleton() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Skeleton className="w-64 h-8 mx-auto mb-4" />
          <Skeleton className="w-96 h-5 mx-auto" />
        </div>

        <ProductListSkeleton count={12} />

        <div className="text-center mt-12">
          <Skeleton className="w-40 h-12 mx-auto rounded-md" />
        </div>
      </div>
    </section>
  );
}

